import { useQuery } from "@apollo/client";
import { useNavigation } from "@react-navigation/native";
import { Department } from "@towersystems/roam-common/lib/generated-types";
import { toTitleCase } from "@towersystems/roam-common/lib/shared-utils";
import React, { useCallback } from "react";
import { Text, View } from "react-native-ui-lib";
import {
  Page,
  FlatListSearchable,
  Divider,
  FlatActionList,
} from "@towersystems/roam-common-native";
import { DEFAULT_DEPARTMENTS_OPTIONS, QueryDepartments } from "./constants";
import { useDepartmentListScreen } from "./hooks";

export function DepartmentListScreen() {
  const { onSelect } = useDepartmentListScreen();
  const navigation = useNavigation<any>();
  const [term, setTerm] = React.useState("");

  const { data, called, loading } = useQuery<{
    departments: {
      items: Department[];
    };
  }>(QueryDepartments, {
    variables: {
      options: {
        ...DEFAULT_DEPARTMENTS_OPTIONS,
        filter: { name: { contains: term } },
      },
    },
  });

  const searchItems = data?.departments.items || [];
  const items = loading ? [] : searchItems;

  const handleRenderItem = useCallback(({ item }: { item: Department }) => {
    return (
      <FlatActionList.RenderItem
        item={{
          key: item.id,
          title: toTitleCase(item.name),
          subTitle: item.description,
          onPress: () => handleDepartmentSelect(item),
        }}
      />
    );
  }, []);

  function handleDepartmentSelect(department: Department) {
    onSelect(department);
    navigation.goBack();
  }

  const emptyComponent =
    called && !loading ? <Text>No departments to show</Text> : undefined;

  return (
    <Page titleContainerStyle={{ alignItems: "center" }}>
      <View>
        <FlatListSearchable
          placeholder="Search..."
          onChange={(query) => setTerm(query)}
          value={term}
          ItemSeparatorComponent={Divider}
          renderItem={handleRenderItem}
          refreshing={loading}
          data={items}
          scrollEnabled={false}
          ListEmptyComponent={emptyComponent}
        />
      </View>
    </Page>
  );
}
